import { stopCastSession } from "../actions";
import { AudioContextAction } from "models/app/player/AudioContext";

export function userLoggedOut() {
    const context = { action: AudioContextAction.UserLogOut, trace: null };
    stopCastSession(context);
}
